<template>
  <div class="trainBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/trainIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">火车票</div>
        </div>
        <div class="infoBox" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="item">
            <span class="label">时间</span>
            <span class="text">{{ rawData.date }}</span>
          </div>
          <div class="item">
            <span class="label">地点</span>
            <span class="text">{{ rawData.start }}-{{ rawData.end }}</span>
          </div>
        </div>
        <div class="list" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="listItem" v-for="(value, key) in rawData.list" :key="key">
            <div class="p1">
              <div class="left">
                <div class="start">
                  <div class="time">{{ value.departuretime }}</div>
                  <div class="city">{{ value.station }}</div>
                </div>
                <div class="center">
                  <div class="text">{{ value.costtime }}</div>
                  <img
                    class="specialArrowIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/specialArrowIcon.png"
                    alt=""
                  />
                  <div class="text">{{ value.trainno }}</div>
                </div>
                <div class="end">
                  <div class="time">{{ value.arrivaltime }}</div>
                  <div class="city">{{ value.endstation }}</div>
                </div>
                <div class="day" v-if="value.day > 1">
                  +{{ value.day - 1 }}天
                </div>
              </div>
              <div class="rightPriceBox">
                <span class="priceSymbol">¥ </span>
                <span class="priceText">{{ value.pricemin }}</span>
                <span class="span">起</span>
              </div>
            </div>
            <div
              class="p2"
              v-if="value.type == 'G' || value.type == 'D' || value.type == 'C'"
            >
              <div class="p2_item">
                <div class="label">二等</div>
                <div class="value" :class="formatNum(value.numed).color">
                  {{ formatNum(value.numed).str }}
                </div>
              </div>
              <div class="p2_item">
                <div class="label">一等</div>
                <div class="value" :class="formatNum(value.numyd).color">
                  {{ formatNum(value.numyd).str }}
                </div>
              </div>
              <div class="p2_item">
                <div class="label">商务</div>
                <div class="value" :class="formatNum(value.numsw).color">
                  {{ formatNum(value.numsw).str }}
                </div>
              </div>
            </div>
            <div class="p2" v-else>
              <div class="p2_item">
                <div class="label">硬座</div>
                <div class="value" :class="formatNum(value.numyz).color">
                  {{ formatNum(value.numyz).str }}
                </div>
              </div>
              <div class="p2_item">
                <div class="label">硬卧</div>
                <div class="value" :class="formatNum(value.numyw).color">
                  {{ formatNum(value.numyw).str }}
                </div>
              </div>
              <div class="p2_item">
                <div class="label">软卧</div>
                <div class="value" :class="formatNum(value.numrw).color">
                  {{ formatNum(value.numrw).str }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 暂无班次 -->
        <div
          :class="{ isExpire: isExpire }"
          class="noDataBox"
          v-if="rawData && rawData.list.length == 0 && errorMsg == ''"
        >
          <div class="topLine"></div>
          <img
            class="noDataIcon"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/noSchDataIcon.png"
            alt=""
          />
          <div class="text">暂无班次</div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div class="bottomBar" :class="{ isExpire: isExpire }">
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test_app: "https://m.ly.com/trainnin1/touch/#/index?refid=2000020811",
    prod_app: "https://m.ly.com/trainnin1/touch/#/index?refid=2000020811",
    test_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    prod_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
  },
  cxnt: {
    test_app: "https://m.ly.com/trainnin1/touch/#/index?refid=2000118572",
    prod_app: "https://m.ly.com/trainnin1/touch/#/index?refid=2000118572",
    test_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
    prod_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  props: ["businessContent"],
  data: function () {
    return {
      isExpire: false,
      timer: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
    };
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
      this.bizReq = JSON.parse(this.businessContent.bizReq);
      console.log(this.rawData);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }

    this.checkIsExpire(this.businessContent);
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpPage();
        }, 1000);
      } else {
        this.jumpPage();
      }
    },
    // 跳到h5或者小程序原生
    jumpPage: function () {
      // 如果是小程序
      if (window.__wxjs_environment) {
        let url = `/pages/JumpThirdWechatProgram/JumpThirdWechatProgram?url=${encodeURIComponent(
          config[this.businessContent.channel][env + "_wechat"]
        )}`;
        wx.miniProgram.navigateTo({
          url,
        });
      }
      // 否则是app环境
      else {
        let url = config[this.businessContent.channel][env + "_app"];
        url = url + `&thirdMemberId=${window.localStorage.getItem("appId_AI")}`;
        window.location.href = url;
      }
    },
    // 传入票数字符串，返回格式化的字符串
    formatNum: function (str) {
      switch (str) {
        case "有":
          return {
            str: "有票",
            color: "green",
          };
        case "无":
          return {
            str: "无",
            color: "black",
          };
        case "-":
          return {
            str: "无",
            color: "black",
          };
        default: {
          return {
            str: str + "张",
            color: "green",
          };
        }
      }
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./trainBox.scss";
</style>
